import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg18CopyG = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("path", {
        d: "M11.036 3.2H4.164C2.97 3.2 2 4.17 2 5.364v8.872c0 1.195.97 2.164 2.164 2.164h6.872c1.195 0 2.164-.97 2.164-2.164V5.364c0-1.195-.97-2.164-2.164-2.164M4.164 4.4h6.872c.532 0 .964.432.964.964v8.872a.964.964 0 0 1-.964.964H4.164a.964.964 0 0 1-.964-.964V5.364c0-.532.432-.964.964-.964"
      }), /*#__PURE__*/jsx("path", {
        d: "M14.9 14a.6.6 0 0 0 .592-.503l.008-.097V3.364c0-1.143-.887-2.08-2.01-2.159l-.154-.005H5.5a.6.6 0 0 0-.097 1.192L5.5 2.4h7.836c.494 0 .902.372.958.852l.006.112V13.4a.6.6 0 0 0 .6.6"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18CopyG$1 = Svg18CopyG;

export { Svg18CopyG$1 as default };
